module.exports = __webpack_public_path__ + "img/发光.84f4e926.png";